import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → Forecast (C-16 S3, GLE-8410). The page ships dark and switches on
 * after its backtest (coordinator decision C16-D444), so the entry waits
 * for `manage/me.features.forecast` inside a window from the switch-on day
 * (2026-10-27 ET at the earliest, C16-D460) to 30 days after, and each LGA
 * and Admin sees it on two ET days (C16-D425).
 */
export const FORECAST_2026_10_28: WhatsNewEntryI = {
  id: "2026-10-28-forecast",
  feature: "forecast",
  startsAt: "2026-10-27T04:00:00.000Z",
  endsAt: "2026-11-27T05:00:00.000Z",
  title: {
    [LGA]: "Forecast is now under Team",
    [ADMIN]: "Forecast is now under Team",
  },
  intro: {
    [LGA]:
      "See where this month will land for your campaigns, and which ones need attention.",
    [ADMIN]:
      "See where this month will land for every workspace, and which campaigns need attention.",
  },
  sections: [
    {
      id: "forecast",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Team → Forecast",
      items: [
        "Month-end qualified meetings with a likely range, the money they bring, and whether you're likely to hit your targets.",
        "The month so far against the forecast, the target pace and last month.",
        "Where the forecast comes from: qualified so far, waiting for feedback, booked, and still to book.",
        "Every campaign's forecast, % of target, history and churn risk. Click one for its pace, rates and last six months.",
        "Switch to next month for an early look.",
      ],
      link: { label: "Open Forecast", href: Router.manageForecast() },
    },
    {
      id: "forecast-admin",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Admin only",
      items: ["Open any workspace's Forecast, or All workspaces at once."],
    },
  ],
};
